const PUBLIC_WATCH_ROUTE = "/video/[id]";
const RESERVED_VIDEO_SEGMENTS = new Set(["create", "create-shorts", "create-package", "demo"]);

function normalizePathname(pathname: string): string {
    return pathname.split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";
}

/**
 * Public watch page (`/video/:id`), including the Pages Router pattern
 * `/video/[id]`. Editor/create routes under `/video` are not public watch pages.
 */
export function isPublicWatchPagePath(pathname: string | null | undefined): boolean {
    if (!pathname) {
        return false;
    }

    const path = normalizePathname(pathname);
    if (path === PUBLIC_WATCH_ROUTE) {
        return true;
    }

    const parts = path.split("/").filter(Boolean);
    return (
        parts.length === 2 &&
        parts[0] === "video" &&
        !RESERVED_VIDEO_SEGMENTS.has(parts[1])
    );
}
